export class DistrictMiniEntity {
  regionId?: number
  regionName?: string | null
  numberOfDistricts?: number
}
